export const enum Genders {
    Male = "male",
    Female = "female",
}
